import {connect} from 'react-redux';
import VirtualEntryList from './VirtualEntryList.jsx';
import {
  handleCaptainDetailsLinkClick,
  handleSaveVirtualEventEntriesBowlers,
  handlePayBalanceClick,
  handlePayBalanceOtherClick
} from './actions';
import {handleWebHooksClick} from 'shared/webHooks/actions';
import {ENVIRONMENT} from 'shared/variables';

const mapStateToProps = state => ({
  virtualEventId: state.admin.virtualEventDetail.virtualEventId,
  virtualEntries: state.admin.virtualEventDetail.virtualEntries,
  bowlers: state.admin.virtualEventDetail.bowlers,
  teams: state.admin.virtualEventDetail.teams,
  submitting: state.admin.virtualEventDetail.submitting,
  balance: state.admin.virtualEventDetail.balance,
  selectedBalance: state.admin.virtualEventDetail.selectedBalance,
  environment: ENVIRONMENT
});

const mapDispatchToProps = dispatch => ({
  onSaveChangesClick: virtualEventId => dispatch(handleSaveVirtualEventEntriesBowlers(virtualEventId)),
  onCaptainDetailsLinkClick: () => dispatch(handleCaptainDetailsLinkClick()),
  onPayBalanceClick: () => dispatch(handlePayBalanceClick()),
  onPayBalanceOtherClick: () => dispatch(handlePayBalanceOtherClick()),
  onWebHooksClick: (checked) => dispatch(handleWebHooksClick(checked))
});

export default connect(mapStateToProps, mapDispatchToProps)(VirtualEntryList);



// WEBPACK FOOTER //
// ./src/features/admin/virtualEventDetail/VirtualEntryListContainer.jsx